const CSV_CONTENT_TYPE = 'text/csv;charset=utf-8'
export const UTF8_BOM = new Uint8Array([0xef, 0xbb, 0xbf])

export function downloadCSVFromString(
  content: string,
  fileName: string,
  includeBom = true,
): void {
  const encoder = new TextEncoder()
  const contentBytes = encoder.encode(content)
  const parts: BlobPart[] = includeBom
    ? [UTF8_BOM, contentBytes]
    : [contentBytes]
  const blob = new Blob(parts, { type: CSV_CONTENT_TYPE })
  downloadFile(blob, fileName)
}

export function downloadFileCSV(
  data: Uint8Array,
  fileName: string,
  includeBom = true,
): void {
  const dataView = new Uint8Array(data)
  const parts: BlobPart[] = includeBom ? [UTF8_BOM, dataView] : [dataView]
  const blob = new Blob(parts, { type: CSV_CONTENT_TYPE })
  downloadFile(blob, fileName)
}

export function downloadFileZip(data: Uint8Array, filename: string): void {
  const blob = new Blob([new Uint8Array(data)])
  downloadFile(blob, filename)
}

function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.setAttribute('download', filename)
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
